module.exports = __webpack_public_path__ + "media/yun.083ca4de.mp4";